declare namespace $ {

	type $mol_view__sub_bog_smalljs_structure_step_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_structure_step_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_structure_step_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_structure_step_4 = $mol_type_enforce<
		ReturnType< $bog_smalljs_structure_step['body_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_smalljs_structure_step extends $mol_view {
		Number( ): $mol_view
		Text( ): $mol_view
		Code( ): $mol_view
		body_content( ): readonly(any)[]
		Body( ): $mol_view
		number( ): string
		text( ): string
		code( ): string
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=step.view.tree.d.ts.map